import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { TablerIconsModule } from "angular-tabler-icons";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { NavService } from "../../../../../../../../shared/src/lib/services/nav.service";
import { NavItem } from "../../../vertical/sidebar/nav-item/nav-item";
import { ApiService } from "../../../../../../../../shared/src/lib/services/api.service";
import { environment } from "../../../../../../../../shared/src/lib/environments/environment";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-horizontal-nav-item",
  standalone: true,
  imports: [TablerIconsModule, CommonModule, MatIconModule, RouterModule, MatButton],
  templateUrl: "./nav-item.component.html",
  styleUrl: "nav-item.component.scss",
})
export class AppHorizontalNavItemComponent implements OnInit {
  @Input() depth: any;
  @Input() item: any;
  private betTickerWindow: Window | null = null;
  constructor(
    public navService: NavService,
    public router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {}

  onItemSelected(item: any) {
    if (item && item.displayName === "Bet Ticker") {
      this.onBetTickerSelected(item);
    } else if (item && item.displayName === "Bet Ticker V1") {
      this.onBetTickerV1Selected(item);
    } else if (item && item.displayName === "KJsport9 Admin") {
      this.onKjsport9Selected(item);
    } else if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
  }

  onKjsport9Selected(item: any) {
    let url = "";
    url = environment.kjsport9URL;
    if (!this.betTickerWindow || this.betTickerWindow.closed) {
      this.betTickerWindow = window.open(url, "kjsport9Tab");
    } else {
      this.betTickerWindow.location.href = url;
      this.betTickerWindow.focus();
    }
    this.cdr.detectChanges();
  }

  onBetTickerV1Selected(item: any) {
    let url = "";
    let oUserData = this.apiService.getUserToken();
    if (oUserData == null) {
      return;
    }
    const accessToken = oUserData.access_token;
    url = environment.betTickerV1URL + "." + this.apiService.getDomainName() + `?token=${accessToken}`;
    if (!this.betTickerWindow || this.betTickerWindow.closed) {
      this.betTickerWindow = window.open(url, "betTickerTab");
    } else {
      this.betTickerWindow.location.href = url;
      this.betTickerWindow.focus();
    }
    this.cdr.detectChanges();
  }
  onBetTickerSelected(item: any) {
    let url = "";
    let oUserData = this.apiService.getUserToken();
    if (oUserData == null) {
      return;
    }
    const accessToken = oUserData.access_token;
    url = environment.betTickerURL + "." + this.apiService.getDomainName() + `?token=${accessToken}`;
    if (!this.betTickerWindow || this.betTickerWindow.closed) {
      this.betTickerWindow = window.open(url, "betTickerTab");
    } else {
      this.betTickerWindow.location.href = url;
      this.betTickerWindow.focus();
    }
    this.cdr.detectChanges();
  }

  openInNewTab(event: MouseEvent, item: any) {
    event.preventDefault();
    const url = this.router.serializeUrl(this.router.createUrlTree([item.route]));
    window.open(url, "_blank");
  }
}
